import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from '../pages/auth/login';
import FindId from '../pages/auth/find-id';
import FindPassword from '../pages/auth/find-password';
import Attendance from '../pages/event/attendance';
import Verify from '../components/join/Verify';

const AuthRouter: FC = () => {
  return (
    <Switch>
      <Route path='/event/attendance' exact component={Attendance} />
      <Route path='/find/id' exact component={FindId} />
      <Route path='/find/password' exact component={FindPassword} />
      <Route path='/find/verify' exact component={Verify} />
      <Route path='/' component={Login} />
    </Switch>
  );
};

export default AuthRouter;
